// Note: The first file of a module here, must also register the module

import "./user-activity-map.component";
import "./user-map.component";
